import React from 'react';
const moves = [{
  number: '1',
  title: 'Plan Light',
  body: 'Undated blocks with margin weeks scheduled on purpose, because over-scheduling is how most homeschool years die.'
}, {
  number: '2',
  title: 'Run on Rhythm',
  body: 'Days anchored to three or four fixed points the kids can run themselves, instead of fragile hour-by-hour slots.'
}, {
  number: '3',
  title: 'Log What Matters',
  body: 'Five minutes a day, blank configurable fields, and the end of the keep-everything reflex.'
}, {
  number: '4',
  title: 'Reset Weekly',
  body: 'Twenty minutes that close the week, restart the system after any derailed stretch, and make week three just another week.'
}];
export function Mechanism() {
  return <section aria-labelledby="mechanism-heading" className="w-full bg-cream" data-id="element-163" data-mp="1dat0ltgs5wev">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-164" data-mp="ftc4cs9yz2gs">
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.14em] text-ink-muted" data-id="element-165" data-mp="krnez5839h02">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-serif font-bold text-ink text-2xl sm:text-4xl" data-id="element-166" data-mp="peq5c4ab88vd">
          The Reset Loop™ — four moves, one week.
        </h2>

        <ol className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-8" data-id="element-167" data-mp="fkpurmw9ebf9">
          {moves.map(move => <li key={move.number} className="flex flex-col" data-id="element-168" data-mp="6luoybx4n3ch">
              <span className="font-serif font-black text-3xl text-sage/25 leading-none" aria-hidden="true" data-id="element-169" data-mp="6nfji1jfymac">
                {move.number}
              </span>
              <h3 className="mt-3 font-serif font-bold text-lg text-ink" data-id="element-170" data-mp="3svf4v6bh6ibj">
                {move.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-171" data-mp="1r1z9jw4g0fa8">
                {move.body}
              </p>
            </li>)}
        </ol>

        <p className="mt-12 pt-7 border-t border-cream-dark font-serif text-lg sm:text-xl text-ink" data-id="element-172" data-mp="1n15nl8ak9ajz">
          Every volume in the kit is one of those four moves, made printable.
        </p>
      </div>
    </section>;
}